<template>
  <div class="RichText-box" v-loading="loading" :class="{ 'loading-border': loading }">
    <quill-editor
      id="myQuillEditor"
      class="ql-editor"
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"

    >
    </quill-editor>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor, Quill } from "vue-quill-editor";
import CustomImageUpload from "@/utils/CustomImageUpload";
import imageResize from "quill-image-resize-module";
Quill.register("modules/imageResize", imageResize);
import { ImageDrop } from "quill-image-drop-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageUploader", CustomImageUpload, true);

export default {
  name: "RichText",
  components: {
    quillEditor,

    // // CustomImageUpload,
    // ImageResize
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      loading: "",

      // 富文本功能配置
      editorOption: {
        modules: {
          // 如果想增加事件控制，比如图片的事件，参考我上面vue3的配置，是一样的用法
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ size: ["small", false, "large", "huge"] }],
              [{ font: [] }],
              [{ align: [] }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ header: 1 }, { header: 2 }],
              ["image"],
              [{ direction: "rtl" }],
              [{ color: [] }, { background: [] }],
            ],
            // handlers: {'image': imageHandler}
          },
          imageResize: {}, // 启用插件
          imageUploader: {
            onUploadStart: () => {
              this.loading = true;
            },
            onUploadEnd: () => {
              this.loading = false;
            },
          },
        },
        placeholder: "请输入内容...",
        theme: "snow",
        // 如果要图片拖拽功能，增加下面内容配置
        imageDrop: true, // 拖动加载图片组件。
        imageResize: {
          //调整大小组件。
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white",
          },
          modules: ["Resize", "DisplaySize", "Toolbar"],
        },
      },
    };
  },
  computed: {
    content: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  mounted() {
    console.log(`Quill`, Quill);
    // 注册模块
    // Quill.register("modules/imageResize", ImageResize);
    // Quill.register("modules/imageUploader", CustomImageUpload, true);
  },
  methods: {
    onEditorBlur(e) {
      console.log(`onEditorBlur`, e);
    },
    onEditorFocus(e) {
      console.log(`focus`, e);
    },
    // 内容改变事件
    // html是带标签，text是纯文本
    onEditorChange({ quill, html, text }) {
      console.log(`onEditorChange`, quill);
      console.log(`onEditorChange`, text);
      this.content = html;
      console.log(`content`, this.content);
    },
  },
};
</script>
<style scoped lang="scss">
.RichText-box{
    margin-left: -15px;
}
::v-deep #myQuillEditor {
    // // height: calc(300px - 50px) ;
    // min-height: 200px; /* 最小高度 */
    // max-height: 300px; /* 最大高度 */
}
::v-deep .ql-toolbar.ql-snow + .ql-container.ql-snow{
    height: 250px; /* 减去工具栏的高度 */
}
.loading-border {
  border: 1px solid #d1d5db;
}
::v-deep .ql-editor{
    // line-height: 0.42px;
    // padding: 12px 0px;
}
::v-deep .quill-editor{
    padding-left:0px;
    padding-right:0px;
}
</style>
